import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  useTheme,
  Typography,
  Card,
  Divider,
  CardContent,
} from "@mui/material";
import useDocumentById from "../../hooks/useDocumentById";
import DynamicTable from "../../components/DynamicTable/DynamicTable";
import ShowBudget from "../../components/Budget/ShowBudget";
import formatDateRange from "../../utils/formatDateRange";
import useUserClaims from "../../hooks/useUserClaims";
import { useAuth } from "../../contexts/AuthContext";
import useCollectionData from "../../hooks/useCollectionData";
import { Helmet } from "react-helmet-async";
import { ExportToExcel } from "../../utils/ExportToExcel";
import getRequiredUserData from "../../utils/getBranchInfo";
import generateCustomID from "../../utils/generateCustomID";
import useTableData from "../../hooks/useTableData";
import getData from "../../api/services/DeliveryGuy/getDeliveryGuy";
import { styled } from "@mui/system";

const StyledSummaryCard = styled(Card)(({ theme }) => ({
  borderRadius: "1.5rem",
  backgroundColor: theme.palette.background.alt,
  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  transition: "transform 0.2s ease-in-out",
  position: "relative",
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
  width: "40%",
  minWidth: 320,
  maxWidth: 600,
  "&:hover": {
    transform: "scale(1.02)",
    boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
  },
}));

const InfoRow = ({ label, value }) => (
  <Box display="flex" justifyContent="space-between" mb={1}>
    <Typography color="text.secondary" fontWeight={600}>
      {label}
    </Typography>
    <Typography color="text.primary" fontWeight={500}>
      {value}
    </Typography>
  </Box>
);

const columns = [
  { key: "dayRange", title: "Date" },
  { key: "totalExpense", title: "Total Expense" },
  { key: "totalIncome", title: "Total Income" },
  { key: "totalCredit", title: "Total Credit" },
  { key: "Sheetstatus", title: "Status" },
  { key: "amount", title: "amount" },
];

const containerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const flexItemStyle = {
  flex: 9,
};

const flexItemStyles = {
  flex: 1,
};

const BudgetPage = () => {
  const theme = useTheme();
  const storedData = localStorage.getItem("userData");
  let active = "";
  let branchId = "";
  const userData = getRequiredUserData();
  if (storedData) {
    const userData = JSON.parse(storedData);
    active = userData ? userData.active : "try";
    branchId = userData ? userData.id : "try";
  }

  if (!active) {
    const storedData2 = localStorage.getItem("active");
    if (storedData2) {
      const userData = JSON.parse(storedData2);
      active = userData ? userData.active : "try";
    }
  }

  // const { documentData } = useDocumentById("Bank", branchId);
  const { user } = useAuth();
  const userClaims = useUserClaims(user);
  const { documentData: documentData2 } = useDocumentById("Budget", branchId);
  const { documentData: finance } = useDocumentById("finance", user.uid);
  const { documentData: status } = useDocumentById(
    "Status",
    active ? active : branchId
  );

  const { data: AllBranch } = useCollectionData("Budget");

  // const { documentData: totalCredit } = useDocumentById(
  //   "totalCredit",
  //   branchId
  // );

  const customerCreditTotalId = generateCustomID(
    `${userData.requiredId}-customer`
  );
  const staffCreditTotalId = generateCustomID(`${userData.requiredId}-staff`);
  const dailyCreditTotalId = generateCustomID(`${userData.requiredId}-daily`);
  const { documentData: totalCustomerCredit } = useDocumentById(
    "totalCredit",
    customerCreditTotalId
  );

  const { documentData: totalStaffCredit } = useDocumentById(
    "totalCredit",
    staffCreditTotalId
  );

  const { documentData: totalDailyCredit } = useDocumentById(
    "totalCredit",
    dailyCreditTotalId
  );

  // Use tableDaySummary from useTableData and userData.activeDailySummery
  // const { data: tableDaySummary } = useTableData(
  //   userData.activeDailySummery || "dummy"
  // );

  const { data: table } = useTableData(active || "dummy");

  // --- Fetch Calculator document for the current active sheet using getData utility ---
  const [calculator, setCalculator] = useState({
    sum: 0,
    actual: 0,
    balance: 0,
  });
  useEffect(() => {
    if (!userData.active) return;
    const unsubscribe = getData(
      "Calculator",
      "active",
      userData.active,
      setCalculator
    );
    console.log("CAlculator", calculator);
    return () => {
      if (typeof unsubscribe === "function") unsubscribe();
    };
  }, [userData.active]);
  const { documentData: bank } = useDocumentById("Bank", branchId);

  const [updatedSheetSummery, setUpdatedSheetSummery] = useState([]);
  // const [totalFromAllBranch, setTotalFromAllBranch] = useState(0);
  useEffect(() => {
    if (AllBranch && AllBranch.length > 0) {
      // Calculate the sum of "total" values from the AllBranch array
      // const sumFromAllBranch = AllBranch?.reduce((accumulator, branch) => {
      //   return accumulator + (branch.total || 0); // Use 0 as the default value if 'total' is undefined
      // }, 0);
      // Set the sum in state
      // setTotalFromAllBranch(sumFromAllBranch);
    }
    // Calculate the sum and update updatedSheetSummery when bank, totalCredit, or status changes
    if (bank && documentData2) {
      let newRow = {};

      if (status) {
        const date = formatDateRange(status?.createdDate);
        const {
          id,
          ethioTelAccount,
          ethioTelOwnerName,
          wifiOwnerName,
          wifiAccount,
          houseRentOwnerName,
          houseRentAccount,
          taxPersentage,
          ...restOfStatus
        } = status;

        newRow = {
          ...restOfStatus,
          dayRange: date,
          totalCredit:
            (totalCustomerCredit?.customerCreditTotal || 0) +
            (totalStaffCredit?.staffCreditTotal || 0) +
            (totalDailyCredit?.dailyCreditTotal || 0),
          Sheetstatus:
            restOfStatus.totalIncome - restOfStatus.totalExpense > 0
              ? "Profit"
              : "Loss",
          amount: restOfStatus.totalIncome - restOfStatus.totalExpense,
        };
      }

      const updatedSheetSummary = documentData2?.sheetSummary?.map(
        (summaryItem) => {
          const {
            ethioTelAccount,
            ethioTelOwnerName,
            wifiOwnerName,
            wifiAccount,
            houseRentOwnerName,
            houseRentAccount,
            taxPersentage,
            ...rest
          } = summaryItem;

          return {
            ...rest,
          };
        }
      );

      let combinedSummery = [];
      if (Object.keys(newRow).length !== 0) {
        combinedSummery = [...(updatedSheetSummary ?? []), newRow];
      } else {
        combinedSummery = [...(updatedSheetSummary ?? [])];
      }

      // Update the state with the combined summery
      setUpdatedSheetSummery(combinedSummery);
    }
  }, [
    bank,
    totalCustomerCredit,
    totalDailyCredit,
    totalStaffCredit,
    status,
    documentData2,
  ]);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Budget </title>
        {/* <link rel="canonical" href="http://localhost:3000/" /> */}
        <meta name="description" content="budget page" />
      </Helmet>
      <Box
        m="1.5rem 2.5rem"
        sx={{
          backgroundColor: theme.palette.background.default,
          height: "100%",
          position: "relative",
        }}
      >
        <div style={containerStyle}>
          <div style={flexItemStyle}></div>
          <div style={flexItemStyles}>
            {userClaims.superAdmin || userClaims.finance ? (
              <ExportToExcel
                file={"Budget"}
                branchId={branchId}
                id={""}
                endpoint={"budget"}
                clear={true}
                name={`Budget-${userData.branchName}`}
              />
            ) : null}
          </div>
        </div>
        {documentData2 ? (
          <>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <ShowBudget
                  label={"Total Budget"}
                  value={
                    userClaims.finance
                      ? finance?.budget
                        ? finance?.budget
                        : "Not available"
                      : documentData2?.budget
                      ? documentData2?.budget
                      : "Not available"
                  }
                  marginTop={10}
                />
              </Grid>
              <Grid item xs={6}></Grid>
            </Grid>

            {updatedSheetSummery.length !== 0 ? (
              <DynamicTable
                data={updatedSheetSummery}
                columns={columns}
                // loadMoreData={loadMoreData}
              />
            ) : null}

            {!userClaims.finance && (
              <>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <ShowBudget
                      label={"Final Budget"}
                      value={
                        documentData2?.budget
                          ? documentData2?.budget?.toFixed(2)
                          : "Not available"
                      }
                      marginTop={10}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <ShowBudget
                      label={"All Credit"}
                      value={(
                        (totalCustomerCredit?.customerCreditTotal || 0) +
                        (totalStaffCredit?.staffCreditTotal || 0) +
                        (totalDailyCredit?.dailyCreditTotal || 0)
                      ).toFixed(2)}
                      marginTop={10}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <ShowBudget
                      label={"Next Budget"}
                      value={
                        documentData2 && status
                          ? (
                              documentData2?.budget -
                              (
                                (totalCustomerCredit?.customerCreditTotal ||
                                  0) +
                                (totalStaffCredit?.staffCreditTotal || 0) +
                                (totalDailyCredit?.dailyCreditTotal || 0)
                              ).toFixed(2) +
                              (status?.totalIncome ? status?.totalIncome : 0)
                            )?.toFixed(2)
                          : "Not available"
                      }
                      marginTop={10}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <ShowBudget
                      label={"Bank Balance"}
                      value={bank ? bank?.total?.toFixed(2) : "Not available"}
                      marginTop={10}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <ShowBudget
                      label={"Total Expense"}
                      value={
                        documentData2
                          ? documentData2?.total?.toFixed(2)
                          : "Not available"
                      }
                      marginTop={10}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    {/* <ShowBudget
                      label={"Bank Balance"}
                      value={bank?.total}
                      marginTop={10}
                    /> */}
                  </Grid>
                </Grid>
              </>
            )}
            {userClaims.finance && (
              <>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <ShowBudget
                      label={"Total Status"}
                      value={documentData2?.total?.toFixed(2)}
                      marginTop={10}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    {/* <ShowBudget
                      label={"Next Budget"}
                      value={
                        parseFloat(finance.budget) +
                        parseFloat(totalFromAllBranch)
                      }
                      marginTop={10}
                    /> */}
                  </Grid>
                </Grid>
              </>
            )}
            {/* --- Styled summary card for requested key-value pairs --- */}
            <StyledSummaryCard>
              <CardContent sx={{ p: 5 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                  <Typography variant="h6" fontWeight="bold">
                    Summary
                  </Typography>
                  <Typography variant="h4" color="text.secondary" fontWeight="bold">
                    {userData?.branchName || "Branch"}
                  </Typography>
                </Box>
                <InfoRow
                  label="Total sales"
                  value={
                    status?.totalIncome !== undefined
                      ? Number(status.totalIncome).toFixed(2)
                      : "Not available"

                    // Array.isArray(tableDaySummary) &&
                    // tableDaySummary.length > 0 &&
                    // tableDaySummary[tableDaySummary.length - 1]?.total !==
                    //   undefined
                    //   ? Number(
                    //       tableDaySummary[tableDaySummary.length - 1]?.total
                    //     ).toFixed(2)
                    //   : "Not available"
                  }
                />
                <Divider sx={{ my: 1 }} />
                <InfoRow
                  label="Total Salary Cost"
                  value={
                    status?.totalStaffSalary !== undefined
                      ? Number(status.totalStaffSalary).toFixed(2)
                      : "Not available"
                  }
                />
                <Divider sx={{ my: 1 }} />
                <InfoRow
                  label="Total Expense"
                  value={
                    status?.totalExpense !== undefined
                      ? Number(status.totalExpense).toFixed(2)
                      : "Not available"
                  }
                />
                <Divider sx={{ my: 1 }} />
                <InfoRow
                  label="Status amount"
                  value={(() => {
                    const totalSales =
                      status?.totalIncome !== undefined
                        ? Number(status.totalIncome)
                        : undefined;
                    // Array.isArray(tableDaySummary) &&
                    // tableDaySummary.length > 0 &&
                    // tableDaySummary[tableDaySummary.length - 1]?.total !==
                    //   undefined
                    //   ? Number(
                    //       tableDaySummary[tableDaySummary.length - 1]?.total
                    //     )
                    //   : undefined;
                    const totalExpense =
                      status?.totalExpense !== undefined
                        ? Number(status.totalExpense)
                        : undefined;
                    if (
                      totalSales !== undefined &&
                      totalExpense !== undefined
                    ) {
                      return (totalSales - totalExpense).toFixed(2);
                    }
                    return "Not available";
                  })()}
                />
                <Divider sx={{ my: 1 }} />
                <InfoRow
                  label="Status"
                  value={(() => {
                    const totalSales =
                      status?.totalIncome !== undefined
                        ? status.totalIncome
                        : undefined;

                    // Array.isArray(tableDaySummary) &&
                    // tableDaySummary.length > 0 &&
                    // tableDaySummary[tableDaySummary.length - 1]?.total !==
                    //   undefined
                    //   ? tableDaySummary[tableDaySummary.length - 1]?.total
                    //   : undefined;
                    const totalExpense =
                      status?.totalExpense !== undefined
                        ? status.totalExpense
                        : undefined;
                    if (
                      totalSales !== undefined &&
                      totalExpense !== undefined
                    ) {
                      return parseFloat(totalSales) - parseFloat(totalExpense) >
                        0
                        ? "Profit"
                        : "Loss";
                    }
                    return "Not available";
                  })()}
                />
                <Divider sx={{ my: 1 }} />
                <InfoRow
                  label="Total staff credit"
                  value={
                    totalStaffCredit?.staffCreditTotal !== undefined
                      ? Number(totalStaffCredit.staffCreditTotal).toFixed(2)
                      : "Not available"
                  }
                />
                <Divider sx={{ my: 1 }} />
                <InfoRow
                  label="Total customer credit"
                  value={
                    totalCustomerCredit?.customerCreditTotal !== undefined
                      ? Number(totalCustomerCredit.customerCreditTotal).toFixed(
                          2
                        )
                      : "Not available"
                  }
                />
                <Divider sx={{ my: 1 }} />
                <InfoRow
                  label="Cash on bank"
                  value={
                    bank?.total !== undefined
                      ? Number(bank.total).toFixed(2)
                      : "Not available"
                  }
                />
                <Divider sx={{ my: 1 }} />
                <InfoRow
                  label="Cash on Hand"
                  value={
                    calculator && calculator.sum !== undefined
                      ? Number(calculator.sum).toFixed(2)
                      : "Not available"
                  }
                />
                <Divider sx={{ my: 1 }} />
                {/* <InfoRow
                  label="Actual"
                  value={(() => {
                    if (
                      documentData2 &&
                      bank
                      // Array.isArray(tableDaySummary) &&
                      // tableDaySummary.length > 0
                    ) {
                      return (
                        documentData2.budget +
                        (table[table.length - 1]?.total -
                          ((totalCustomerCredit?.customerCreditTotal || 0) +
                            (totalDailyCredit.dailyCreditTotal || 0) +
                            (totalStaffCredit.staffCreditTotal || 0))) -
                        (bank.total || 0)
                      )?.toFixed(2);
                    }
                    return "Not available";
                  })()}
                />
                <Divider sx={{ my: 1 }} /> */}
                <InfoRow
                  label="Balance"
                  value={(() => {
                    if (
                      calculator &&
                      calculator.sum !== undefined &&
                      documentData2 &&
                      bank
                      // Array.isArray(tableDaySummary) &&
                      // tableDaySummary.length > 0
                    ) {
                      return documentData2 && calculator
                        ? (
                            calculator.sum.toFixed(2) -
                            (
                              documentData2.budget +
                              (table[table.length - 1]?.total -
                                ((totalCustomerCredit?.customerCreditTotal ||
                                  0) +
                                  (totalDailyCredit.dailyCreditTotal || 0) +
                                  (totalStaffCredit.staffCreditTotal || 0))) -
                              (bank.total || 0)
                            )?.toFixed(2)
                          )?.toFixed(2)
                        : "Not available";
                    }
                  })()}
                />
              </CardContent>
            </StyledSummaryCard>
          </>
        ) : (
          <></>
        )}
      </Box>
    </>
  );
};

export default BudgetPage;
